<template>
  <div class="login-container">
    <Card class="login-card">
      <template #title>
        <h3>Login</h3>
      </template>
      <template #content>
        <form @submit.prevent="handleLogin">
          <div class="p-fluid">
            <div class="p-field">
              <label for="username">Username</label>
              <InputText id="username" v-model="username" />
            </div>
            <div class="p-field">
              <label for="password">Password</label>
              <Password id="password" v-model="password" :feedback="false" />
            </div>
            <Button label="Login" type="submit" class="p-mt-2"></Button>
            <p v-if="error" class="error">{{ error }}</p>
          </div>
        </form>
      </template>
    </Card>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '../services/api';
import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';

const username = ref('');
const password = ref('');
const error = ref(null);
const router = useRouter();

const handleLogin = async () => {
  error.value = null; // Reset error on new attempt
  let token = null;

  try {
    const params = new URLSearchParams();
    params.append('username', username.value);
    params.append('password', password.value);

    const response = await api.post('/token', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    const { access_token, refresh_token } = response.data;
    if (access_token && refresh_token) {
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        localStorage.setItem('user', username.value);
        router.push('/dashboard');
    } else {
        throw new Error("Token not found in response");
    }

  } catch (err) {
    console.error('Login failed:', err);
    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      error.value = `Error: ${err.response.data.detail || 'Invalid credentials'}`;
    } else {
      // Something happened in setting up the request that triggered an Error
      error.value = 'An unexpected error occurred. Please try again.';
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
}
.login-card {
  width: 360px;
}
.p-field {
  margin-bottom: 1rem;
}
.error {
  color: red;
  margin-top: 1rem;
}
</style>
